import { useEffect, useState } from "react";
import { publicApi } from "../admin/api";

let _cache = null;

/**
 * Fetches public site settings once, caches in-memory for the session.
 * Re-fetches on admin changes if you call `invalidateSettings()` (not yet used).
 */
export function useSettings() {
  const [settings, setSettings] = useState(_cache);

  useEffect(() => {
    if (_cache) {
      setSettings(_cache);
      return;
    }
    publicApi
      .get("/settings")
      .then((r) => {
        _cache = r.data;
        setSettings(r.data);
      })
      .catch(() => {});
  }, []);

  return settings;
}

export function invalidateSettings() {
  _cache = null;
}
